import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslations from './locales/en.json'
import esTranslations from './locales/es.json'
import cnTranslations from './locales/cn.json'

export const normalizeLanguageCode = (code: string): keyof typeof resources => {
  const baseCode = code.toLowerCase().split('-')[0] as keyof typeof resources
  return resources[baseCode] ? baseCode : 'en'
}

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  zh: { translation: cnTranslations },
}

export const initializeI18n = () => {
  const detectedLanguage = normalizeLanguageCode(navigator.language || 'en')

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      lng: detectedLanguage,
      fallbackLng: ['en'],
      load: 'languageOnly',
      cleanCode: true,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['navigator', 'localStorage', 'cookie'],
        caches: ['localStorage', 'cookie'],
      },
    })
}

export default i18n
